export default "__VITE_ASSET__BgSU9Eak__"